import {
  isBooleanInventoryListingConfig,
  isClassificationInventoryListingConfig,
  isNumberInventoryListingConfig
} from "@dealer-center/ddc-pages-inventory-config-interface";
import type { getDifferencesBetweenConfigsReturn } from "./helper";
import {
  RenderBooleanChange,
  RenderClassificationChange,
  RenderNumberChange,
  RenderStatusChange,
  RenderStringChange
} from "./items";

export interface SaveModalPickItemToRenderInterface {
  change: getDifferencesBetweenConfigsReturn;
}

export const SaveModalPickItemToRender = ({
  change
}: SaveModalPickItemToRenderInterface) => {
  if (
    isClassificationInventoryListingConfig(change.oldValue) ||
    isClassificationInventoryListingConfig(change.newValue)
  )
    return (
      <RenderClassificationChange
        config={change.config}
        key={change.config}
        newValue={change.newValue}
        oldValue={change.oldValue}
      />
    );
  else if (change.config === "statusList")
    return (
      <RenderStatusChange
        config={change.config}
        key={change.config}
        newValue={change.newValue}
        oldValue={change.oldValue}
      />
    );
  else if (
    isBooleanInventoryListingConfig(change.oldValue) ||
    isBooleanInventoryListingConfig(change.newValue)
  )
    return (
      <RenderBooleanChange
        config={change.config}
        key={change.config}
        newValue={change.newValue}
        oldValue={change.oldValue}
      />
    );
  else if (
    isNumberInventoryListingConfig(change.oldValue) ||
    isNumberInventoryListingConfig(change.newValue)
  )
    return (
      <RenderNumberChange
        config={change.config}
        key={change.config}
        newValue={change.newValue}
        oldValue={change.oldValue}
      />
    );
  else {
    return (
      <RenderStringChange
        config={change.config}
        key={change.config}
        newValue={change.newValue}
        oldValue={change.oldValue}
      />
    );
  }
};
